export enum ViewingMode {
  DESKTOP = 'desktop',
  PHONE = 'phone',
}
